import { CSSProperties } from 'react'
import { PulseLoader } from 'react-spinners'

import theme from 'styles/Theme'

import { PageLoadingContainer } from './styled'

export interface PageLoadingProps {
  style?: CSSProperties
}

export function PageLoading({ style }: PageLoadingProps): JSX.Element {
  return (
    <PageLoadingContainer style={style}>
      <PulseLoader color={theme.colors.primary} size="24px" margin="8px" />
    </PageLoadingContainer>
  )
}
